import { stringify } from "query-string";
import { getEnvironmentConfig } from "~/modules/config";
import { generateProofKey } from "../AuthenticatorHelpers/generateProofKey";
import { buildRegionalHost } from "~/utils/regionUtil";
import { LoginDetailsParams, LoginDetailsResponse } from "./types";

export const getLoginDetails = async (options: LoginDetailsParams): Promise<LoginDetailsResponse> => {
    const environmentConfig = getEnvironmentConfig();
    const { region, regionNonFlex } = environmentConfig || {};
    const configRegion = regionNonFlex || region;
    const regionToUse = buildRegionalHost(configRegion || "");
    const twilioSSORedirectUrl = `https://flex${regionToUse}.twilio.com/callback`;
    const twilioSSOServiceUrl = `https://services${regionToUse}.twilio.com/v1/Flex/Authorize`;
    const twilioSSOAuthCallback = `https://services${regionToUse}.twilio.com/v1/Flex/Authentication/Callback`;

    const redirectUrlParam = options.redirectUrl || twilioSSORedirectUrl;
    const { nonce, codeChallenge, state, codeVerifier } = await generateProofKey(options.clientId, redirectUrlParam);
    const queryParams = stringify(
        {
            isConsoleLogin: options.isConsoleLogin,
            redirectUrl: encodeURIComponent(options.redirectUrl || twilioSSOAuthCallback),
            nonce,
            codeChallenge,
            state,
            appType: options.appType,
            ssoProfileSid: !options.isConsoleLogin && options.ssoProfileSid,
            accountSid: options.isConsoleLogin ? options.accountSid : undefined,
            instanceSid: options.isConsoleLogin ? options.instanceSid : undefined
        },
        { encode: false, sort: false }
    );

    return { loginUrl: `${twilioSSOServiceUrl}?${queryParams}`, nonce, codeChallenge, state, codeVerifier };
};
